module.exports = __webpack_public_path__ + "static/media/sidebar_logo_w.123b6c04.png";